import { faqCusto, faqDados, faqProgramar, faqSistema } from './shared'
import type { ProfessionPageConfig } from './types'

export const financeiro: ProfessionPageConfig = {
  path: '/ia-para-financeiro-e-cobranca/',
  key: 'financeiro',
  title: 'IA para financeiro e cobrança de pequena empresa | Oficina IA',
  description:
    'Três tarefas do financeiro que a IA adianta numa pasta: extrato batido com a planilha, mensagens de cobrança por vencimento e o fluxo de caixa do mês.',
  imageAlt: 'Oficina IA: IA para financeiro e cobrança',
  whatsappMessage: 'Olá, Arthur. Vim pela página de IA para financeiro e cobrança e quero saber sobre o acompanhamento.',
  lastmod: '2026-09-25',
  heading: 'IA para financeiro e cobrança',
  intro:
    'Extrato de um lado, planilha do outro, e a cobrança feita de cabeça no fim do mês. Aqui estão três tarefas desse aperto que a IA pode ajudar a adiantar, sem programar.',
  rogerio: { pose: 'conferindo', text: 'O que não bate aparece. O resto eu deixo quieto.' },
  tasks: [
    {
      title: 'Extrato batido com a planilha',
      tone: 'sky',
      brings: 'o extrato do banco e a planilha de contas.',
      helps: 'marca o que entrou, o que faltou e o que não bate.',
      continues: 'resolve só o que não bateu.',
    },
    {
      title: 'Cobrança por vencimento',
      tone: 'peach',
      brings: 'a planilha de clientes com vencimentos.',
      helps: 'escreve uma mensagem por cliente, no seu tom, com valor e data.',
      continues: 'revisa e manda.',
    },
    {
      title: 'Fluxo de caixa do mês',
      tone: 'sage',
      brings: 'as notas e os comprovantes do mês.',
      helps: 'monta o fluxo de caixa: entradas, saídas e o que ficou.',
      continues: 'confere com o extrato e decide.',
    },
  ],
  steps: {
    do: 'A IA marca o extrato, escreve as cobranças ou monta o fluxo dentro da sua pasta.',
    check: 'Confira os valores antes de cobrar ou decidir. A IA pode se enganar; o dinheiro é responsabilidade sua.',
    resume: 'No mês seguinte, troque o extrato e a planilha e repita o pedido.',
  },
  faq: [faqProgramar, faqSistema('sistema financeiro'), faqDados('do banco e dos clientes'), faqCusto],
  closing: {
    title: 'Seu primeiro mês batido, com alguém do lado.',
    text: 'Traga o extrato, a planilha de contas e a cobrança do fim do mês.',
    rogerio: 'Eu cuido do novelo. Você cuida do caixa.',
  },
}
